import { createUseStyles } from 'react-jss';

export const useStyles = createUseStyles({
    // Splash 'Welcome back' classes
    splashWrapper: {
        display: 'flex',
        flexDirection: 'column',
        textAlign: 'center',
        alignItems: 'center',
        width: '100%',
        marginTop: '4.5rem'
    },
    splashHeaderWrapper: {
        marginBottom: '2rem'
    },
    splashHeader: {
        margin: '0 auto'
    },
    // Car verify styles
    errorWrapper: {
        width: '100%',
        marginTop: '5rem',
        '@media (max-device-width: 500px)': {
            marginTop: '4rem'
        }
    },
    car_prefill_verify_wrapper: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '3.5rem',
        width: '100%',
        maxWidth: '72rem',
        marginTop: '2.5rem',
        marginBottom: '2.5rem',
        paddingLeft: '0',
        paddingRight: '0',
        margin: '0 auto',
        '@media (max-device-width: 500px)': {
            paddingLeft: '1rem',
            paddingRight: '1rem',
            flexDirection: 'column',
            gap: '1.5rem'
        }
    },
    carPrefillHeaderWrapper: {
        marginTop: '5rem',
        marginBottom: '1.5rem',
        '@media (max-device-width: 500px)': {
            marginTop: '2rem'
        }
    },
    fullscreenLoaderWrapper: {
        display: 'flex',
        position: 'fixed',
        zIndex: '100',
        top: '0',
        left: '0',
        width: '100vw',
        height: '100vh',
        alignItems: 'center',
        backgroundColor: 'rgba(0, 0, 0, 0.4)'
    },
    carPrefillWrapper: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '0rem',
        width: '100%',
        maxWidth: '72rem',
        margin: '0 auto',
        '@media (max-device-width: 500px)': {
            gap: '1rem'
        }
    },
    autoCompleteWrapper: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'start',
        justifyContent: 'start',
        gap: '1rem',
        margin: '0 auto',
        width: '100%'
    },
    carPrefillLabel: {
        width: '100%',
        marginBottom: 0
    }
});
